import { Serializer } from 'jsonapi-serializer'

export default new Serializer('managed_search', {
  attributes: ['collection', 'originalQuery', 'ctx', 'name', 'query', 'type'],
  collection: {
    ref: 'id',
    included: true
  }
})
